import React from 'react'
import L from 'leaflet'
import { withMap } from './MapContext'

class Layer extends React.Component {
  componentDidMount() {
    this.imageLayer = L.imageOverlay(this.props.url, this.props.bounds)
    this.layers = L.layerGroup([this.imageLayer]).addTo(this.props.map)

    if(this.props.center && this.props.zoom) {
      this.props.map.flyTo(this.props.center, this.props.zoom)
    }
  }

  componentWillUnmount() {
    // this.leafletElement.off('move', this.onViewportChange)
    // this.leafletElement.off('moveend', this.onViewportChanged)
    this.layers.removeLayer(this.imageLayer)
    // this.imageLayer.remove()
  }

  render() {
    return null
  }
}

Layer.defaultProps = {
  url: '',
  bounds: [0,0],
  center: null,
  zoom: 0,
}

export default withMap(Layer)



// WEBPACK FOOTER //
// ./src/components/library/widgets/map/components/Layer.js